export const serverUrl = {
    // baseURL: '/adminApi/',//本地调试/测试环境
    baseURL: 'https://api.yours58.com/adminApi/',//正式环境
    uploadUrl: 'https://api.yours58.com/file/uploadObjectOSS',
    imgUrl: 'https://new-onestand.oss-cn-shanghai.aliyuncs.com/',
}



// WEBPACK FOOTER //
// ./src/utils/server.js